export default __webpack_public_path__ + "static/media/modulo-5.83a3d407.svg";